import { Link } from "react-router-dom";
import MovieCard from "@/components/feature/MovieCard";
import type { Movie } from "@/types/movie";

interface MovieSectionProps {
  eyebrow: string;
  title: string;
  subtitle: string;
  movies: Movie[];
  actionTo: string;
  actionLabel: string;
  ranked?: boolean;
  tone?: "plain" | "tinted";
}

export default function MovieSection({
  eyebrow,
  title,
  subtitle,
  movies,
  actionTo,
  actionLabel,
  ranked = false,
  tone = "plain",
}: MovieSectionProps) {
  return (
    <div
      className={
        tone === "tinted"
          ? "rounded-lg border border-background-200 bg-background-100/70 px-4 py-8 md:px-8 md:py-10"
          : ""
      }
    >
      <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <span className="flex items-center gap-1.5 text-[11px] uppercase tracking-[0.2em] text-primary-600">
            <span className="h-1 w-1 rounded-full bg-accent-500" />
            {eyebrow}
          </span>
          <h2 className="mt-2 font-heading text-xl font-semibold text-foreground-950 md:text-2xl">
            {title}
          </h2>
          <p className="mt-1.5 text-sm text-foreground-500">{subtitle}</p>
        </div>
        <Link
          to={actionTo}
          className="flex w-fit items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3.5 py-2 text-xs text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
        >
          {actionLabel} <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="mt-5 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4 md:gap-4">
        {movies.map((movie, index) => (
          <MovieCard key={movie.id} movie={movie} rank={ranked ? index + 1 : undefined} />
        ))}
      </div>
    </div>
  );
}